export enum FeatureFlagVariant {
    ON = 'on',
    OFF = 'off',
}
